function UsersData() {
    "use strict";

    this.TargetId = -1;

    this.Clean = null;
    this.Dirty = null;
    this.Paginated = null;

    this.CurrentId = -1;
    this.EditingId = -1;

    this.TabsPending = 2;
}
if (typeof exports !== 'undefined') {
    module.exports = UsersData;
}